import { Component, input } from '@angular/core';
import { EventCategory } from 'in-time-core';
import { SelectableTextTheme } from '../../../../ui/components/selectable-text/selectable-text.component';

@Component({
  selector: 'app-event-category-selector-list',
  templateUrl: './event-category-selector-list.component.html',
})
export class EventCategorySelectorListComponent {
  public readonly categories = input.required<EventCategory[]>();
  public readonly selectedCategory = input.required<EventCategory | null>();
  public readonly theme = input<SelectableTextTheme>('dark');
}
